import { RunComponentCommonProps } from '@/types/run-components.type';

export default function RunTextComponent({
  componentMapping
}: RunComponentCommonProps) {
  return (
    <div className="bg-white max-w-full max-h-full md:max-w-[65%] rounded-md border border-gray-400 flex items-stretch">
      <div className="flex items-center p-2 border-r border-gray-400 rounded-l-md bg-[#d4f0ff]">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.3319 13.0381C10.169 13.0381 10.0316 12.9814 9.91962 12.868C9.80765 12.7546 9.75167 12.6169 9.75167 12.4548V4.12789H6.87987C6.71783 4.12789 6.5801 4.07088 6.46668 3.95686C6.35326 3.84283 6.29655 3.70438 6.29655 3.54149C6.29655 3.3786 6.35326 3.24117 6.46668 3.12921C6.5801 3.01725 6.71783 2.96127 6.87987 2.96127H13.7901C13.9521 2.96127 14.0899 3.01828 14.2033 3.13231C14.3167 3.24633 14.3734 3.38478 14.3734 3.54767C14.3734 3.71056 14.3167 3.84799 14.2033 3.95996C14.0899 4.07191 13.9521 4.12789 13.7901 4.12789H10.9183V12.4548C10.9183 12.6169 10.8613 12.7546 10.7473 12.868C10.6332 12.9814 10.4948 13.0381 10.3319 13.0381ZM4.33188 13.0381C4.16899 13.0381 4.03157 12.9814 3.91962 12.868C3.80765 12.7546 3.75167 12.6169 3.75167 12.4548V7.46122H2.2132C2.05117 7.46122 1.91344 7.40421 1.80002 7.29019C1.68659 7.17617 1.62988 7.03771 1.62988 6.87482C1.62988 6.71194 1.68659 6.57451 1.80002 6.46254C1.91344 6.35058 2.05117 6.29461 2.2132 6.29461H6.45677C6.6188 6.29461 6.75653 6.35162 6.86995 6.46564C6.98337 6.57966 7.04008 6.71812 7.04008 6.88101C7.04008 7.0439 6.98337 7.18132 6.86995 7.29329C6.75653 7.40525 6.6188 7.46122 6.45677 7.46122H4.9183V12.4548C4.9183 12.6169 4.86129 12.7546 4.74727 12.868C4.63324 12.9814 4.49478 13.0381 4.33188 13.0381Z"
            fill="black"
            fillOpacity="0.6"
          />
        </svg>
      </div>
      <div className="pl-2 p-1">
        {componentMapping?.component_text?.content}
      </div>
    </div>
  );
}
